import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = {
  key: 0,
  class: "absolute top-0 bottom-0 left-0 right-0"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "h-2 w-full bg-app text-center" }
const _hoisted_5 = { class: "flex-1" }
const _hoisted_6 = { class: "px-2 py-1 flex flex-row" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "1.4em",
  viewBox: "0 0 384 512"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M48 108C48 48.4 96.4 0 156 0s108 48.4 108 108V344c0 39.8-32.2 72-72 72s-72-32.2-72-72V152c0-13.3 10.7-24 24-24s24 10.7 24 24V344c0 13.3 10.7 24 24 24s24-10.7 24-24V108c0-33.1-26.9-60-60-60s-60 26.9-60 60V368c0 53 43 96 96 96s96-43 96-96V152c0-13.3 10.7-24 24-24s24 10.7 24 24V368c0 79.5-64.5 144-144 144s-144-64.5-144-144V108z",
    style: {"fill":"var(--icon-text-color)"}
  })
], -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  height: "1.4em",
  viewBox: "0 0 512 512"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("path", {
  d: "M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z",
  style: {"fill":"var(--icon-text-color)"}
}, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  height: "1.4em",
  viewBox: "0 0 512 512"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("path", {
  d: "M49.9 27.8C15.1 12.7-19.2 50.1-1.2 83.5L68.1 212.2c4.4 8.3 12.6 13.8 21.9 15c0 0 0 0 0 0l176 22c3.4 .4 6 3.3 6 6.7s-2.6 6.3-6 6.7l-176 22s0 0 0 0c-9.3 1.2-17.5 6.8-21.9 15L-1.2 428.5c-18 33.4 16.3 70.8 51.1 55.7L491.8 292.7c32.1-13.9 32.1-59.5 0-73.4L49.9 27.8z",
  style: {"fill":"var(--icon-text-color)"}
}, null, -1)
const _hoisted_14 = [
  _hoisted_13
]

import { computed, getCurrentInstance, inject, onMounted, onUnmounted, ref } from "vue";
import { useGraphqlSdk } from "@/graphql/graphql-client";
import { TextPatch, useChangeWatcher } from "@/features/chat-list/useChangeWatcher";
import { useContactPersistence } from "@/utils/contactPersistence";
import {
  GConnectedServiceChatEntityConversationStartModeItem,
  GCreateConversationContactMessageAttachmentInput,
} from "@/generated/graphql";
import { isNullOrUndefined } from "@/utils/object-utils";
import mitt from "@/utils/mitt";
import { useEmitterOn } from "@/composables/useEmitterOn";
import axios from "axios";
import { createConversation as createConversationHelper } from "@/utils/createConversation";
import preChatSurveyPersistence from "@/utils/preChatSurveyPersistence";
import emitter from "@/utils/mitt";
import { demoModeInjectionKey, settingsInjectionKey } from "@/keys";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatMessage',
  props: {
  conversation: {
    type: String,
    required: false,
  },
},
  setup(__props) {

const props = __props;

const instance = getCurrentInstance();
const tenant = instance?.appContext.config.globalProperties.$tenant;
const connectedService = instance?.appContext.config.globalProperties.$connectedservice;
const settings = inject(settingsInjectionKey);
const demoMode = inject(demoModeInjectionKey);
const contactPersistence = useContactPersistence(tenant);

const textareaWrapper = ref<HTMLDivElement>();
const textArea = ref<HTMLTextAreaElement>();
const text = ref<string>();
const contact = ref();
const conversationRef = ref();
const loading = ref(false);
const fileInput = ref<HTMLInputElement>();
const uploading = ref(false);
const progressValue = ref(30);

const show = ref(false);
const dragCounter = ref(0);

const attachment = ref<GCreateConversationContactMessageAttachmentInput>();

conversationRef.value = props.conversation ? props.conversation.toString() : null;
contact.value = contactPersistence.getState();

const error = ref();
const hasConversation = computed(() => conversationRef.value !== null);
const hasContact = computed(() => contact.value !== null);

const { reset } = useChangeWatcher(textArea, changeDiffHandler, changeSnapshotHandler);

function replicateTextInput() {
  // Textarea input is replicated to textareaWrapper, a magic trick to ensure the textarea grows to the appropriate height
  if (!textareaWrapper.value) {
    return;
  }

  textareaWrapper.value.dataset.replicatedValue = text.value;
}

useEmitterOn("bot-message-received", msg => {
  if (msg.conversation === conversationRef.value) {
    loading.value = false;
  }
});

async function changeDiffHandler(formattedDiffs: TextPatch[], sequence: number) {
  if (!hasContact.value || !hasConversation.value || demoMode) {
    return;
  }

  if (text.value === "") {
    await sendStoppedTyping();
    reset();
  } else {
    const sdk = useGraphqlSdk();
    await sdk.ContactIsTypingInConversation({
      input: {
        conversation: conversationRef.value,
        tenant: tenant,
        contact: contact.value,
        content: JSON.stringify(formattedDiffs),
        sequence: sequence,
        isFullContent: false,
      },
    });
  }
}

async function changeSnapshotHandler(content: string, sequence: number) {
  if (!hasContact.value || !hasConversation.value || demoMode) {
    return;
  }

  if (text.value === "") {
    await sendStoppedTyping();
  } else {
    const sdk = useGraphqlSdk();
    await sdk.ContactIsTypingInConversation({
      input: {
        conversation: conversationRef.value,
        tenant: tenant,
        contact: contact.value,
        content: content,
        sequence: sequence,
        isFullContent: true,
      },
    });
  }
}

async function sendStoppedTyping() {
  if (!hasContact.value || !hasConversation.value || demoMode) {
    return;
  }

  const sdk = useGraphqlSdk();

  await sdk.ContactStoppedTypingInConversation({
    input: {
      conversation: conversationRef.value,
      tenant: tenant,
      contact: contact.value,
    },
  });
}

async function send() {
  if (demoMode) {
    console.log("Demo mode -- aborting send");
    clearTextArea();
    return;
  }

  if (loading.value) {
    console.debug("Stopped send as we're loading");
    return;
  }

  const content = text.value ?? "";
  if (isNullOrUndefined(content) || content.trim() === "") {
    return;
  }

  await sendStoppedTyping();

  loading.value = true;

  if (hasContact.value && hasConversation.value) {
    createNewConversationMessage();
  } else {
    await createConversation();
  }
}

function createNewConversationMessage() {
  const content = text.value ?? "";

  clearTextArea();
  reset();

  const sdk = useGraphqlSdk();
  sdk
    .CreateConversationContactMessage({
      content: content,
      conversation: conversationRef.value,
      contact: contact.value,
      tenant: tenant,
      attachment: attachment.value,
    })
    .then(res => {
      if (
        !isNullOrUndefined(res.createConversationContactMessage) &&
        !isNullOrUndefined(res.createConversationContactMessage.timeline)
      ) {
        mitt.emit("contact-message-sent", {
          id: res.createConversationContactMessage.timeline.id,
          content: content,
          conversation: conversationRef.value,
          noAgentAvailable: res.createConversationContactMessage.noAgentAvailable ?? false,
          botAssistant: res.createConversationContactMessage.botAssistant ?? false,
          attachments:
            res.createConversationContactMessage.timeline.data.__typename === "ConversationContactMessage"
              ? res.createConversationContactMessage.timeline.data.attachments.map(i => {
                  return {
                    filename: i.filename,
                    size: i.size,
                    downloadUrl: i.downloadUrl,
                    previewUrl: i.previewUrl,
                  };
                })
              : [],
        });

        if (!res.createConversationContactMessage.botAssistant) {
          loading.value = false;
        }

        if (res.createConversationContactMessage.noAgentAvailable === true) {
          emitter.emit("no-agents-available");
        }
      } else {
        // TODO: handle in UI
        console.warn("Could not send message");
      }
    })
    .catch(err => {
      loading.value = false;
      // TODO: handle in UI
      console.warn("Could not send message", err);
    })
    .finally(() => {
      attachment.value = undefined;
    });
}

async function createConversation() {
  if (demoMode) {
    console.log("demo mode -- skipping conversation create");
    clearTextArea();
    return;
  }

  let contactMessage = text.value ?? "";

  if (
    settings!.value.behaviour.conversationStartMode ===
    GConnectedServiceChatEntityConversationStartModeItem.StartOnFirstContactMessage
  ) {
    const state = preChatSurveyPersistence.getState();
    const surveyText = state
      ?.filter(i => i.value)
      .map(field => `<b>${field.label}:</b> ${field.value ?? ""}`)
      .join("<br />");

    if (surveyText) {
      contactMessage = surveyText + "<br /><br />" + contactMessage;
    }
  }

  const res = await createConversationHelper(contactMessage, contact.value, tenant, connectedService);
  loading.value = false;
  error.value = res?.error;

  if (!res?.error) {
    clearTextArea();
  }
}

function clearTextArea() {
  text.value = "";
  replicateTextInput();
}

function openFileDialog(): void {
  if (fileInput.value) {
    fileInput.value.click();
  }
}

async function uploadFile(file: File): Promise<void> {
  if (demoMode) {
    console.log("demo mode -- aborting file upload");
    return;
  }

  if (!process.env.VUE_APP_URL) {
    throw new Error("Missing API in env");
  }

  const API_ENDPOINT = process.env.VUE_APP_URL.startsWith("http")
    ? process.env.VUE_APP_URL
    : `https://` + process.env.VUE_APP_URL;

  uploading.value = true;

  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await axios.post(`${API_ENDPOINT}/api/chat-upload?tenant=${tenant}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: progressEvent => {
        if (progressEvent.progress) {
          progressValue.value = progressEvent.progress * 100;
        }
      },
    });

    uploading.value = false;
    progressValue.value = 0;

    attachment.value = {
      blobName: response.data.id,
      contentType: response.data.contentType,
      filename: response.data.filename,
      size: response.data.size,
    };

    createNewConversationMessage();
  } catch (error) {
    uploading.value = false;
    progressValue.value = 0;
    console.error("File upload failed:", error);
    alert("Opplasting av fil var mislykket. Sørg for at filen ikke er større enn 30 MB.");
  }
}

const handleUpload = async (event: Event) => {
  const files = (event.target as HTMLInputElement).files;

  if (files && files.length > 0) {
    await uploadFile(files[0]);
  }
};

onMounted(() => {
  textArea.value?.focus();

  fileInput.value?.addEventListener("change", handleUpload);

  const iframe = document.getElementById("sa-chat-widget-iframe") as HTMLIFrameElement;
  const iframeDocument = iframe.contentDocument || iframe.contentWindow?.document;

  if (iframeDocument) {
    iframeDocument.body.addEventListener("dragenter", handleDragEnter);
    iframeDocument.body.addEventListener("dragleave", handleDragLeave);
    iframeDocument.body.addEventListener("dragend", handleDragEnd);
    iframeDocument.addEventListener("dragover", preventDrop, false);
    iframeDocument.addEventListener("drop", onDrop, false);
  }
});

onUnmounted(() => {
  fileInput.value?.removeEventListener("change", handleUpload);

  const iframe = document.getElementById("sa-chat-widget-iframe") as HTMLIFrameElement;
  const iframeDocument = iframe.contentDocument || iframe.contentWindow?.document;

  if (iframeDocument) {
    iframeDocument.body.removeEventListener("dragenter", handleDragEnter);
    iframeDocument.body.removeEventListener("dragleave", handleDragLeave);
    iframeDocument.body.removeEventListener("dragend", handleDragEnd);
    iframeDocument.removeEventListener("dragover", preventDrop);
    iframeDocument.removeEventListener("drop", onDrop);
  }
});

function preventDrop(event: Event) {
  event.preventDefault();
}

function onDrop(event: Event) {
  event.preventDefault();
  show.value = false;
  dragCounter.value = 0;
}

function handleDragEnter(event: DragEvent) {
  event.preventDefault();
  dragCounter.value++;
  show.value = true;
}

function handleDragLeave(event: DragEvent) {
  event.preventDefault();
  dragCounter.value--;

  if (dragCounter.value === 0) {
    console.log("Drag action ended/aborted");
    show.value = false;
  }
}

function handleDragEnd(event: DragEvent) {
  event.preventDefault();
  console.log("Drag action ended");
  dragCounter.value = 0;
  show.value = false;
}

async function handleFileDrop(event: DragEvent) {
  event.preventDefault();
  show.value = false;

  if (isNullOrUndefined(event) || isNullOrUndefined(event.dataTransfer)) {
    return;
  }

  if (event.dataTransfer.items) {
    // Use DataTransferItemList interface to access the file(s)
    for (let i = 0; i < event.dataTransfer.items.length; i++) {
      if (event.dataTransfer.items[i].kind === "file") {
        const file = event.dataTransfer.items[i].getAsFile();
        if (!isNullOrUndefined(file)) {
          void uploadFile(file);
        }
      }
    }
  } else {
    // Use DataTransfer interface to access the file(s)
    for (let i = 0; i < event.dataTransfer.files.length; i++) {
      const file = event.dataTransfer.files[i];
      if (!isNullOrUndefined(file)) {
        void uploadFile(file);
      }
    }
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (show.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "w-full h-full border-2 border-dashed border-gray-700 rounded-lg text-primary text-lg flex items-center justify-center bg-opacity-10",
            onDrop: handleFileDrop,
            onDragover: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
          }, " Drop your files here ", 32)
        ]))
      : _createCommentVNode("", true),
    (uploading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "bg-top h-full",
              style: _normalizeStyle(`width: ${progressValue.value}%`)
            }, null, 4)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["flex flex-row items-center", {
        invisible: show.value,
      }])
    }, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: "growing-wrapper",
          ref_key: "textareaWrapper",
          ref: textareaWrapper
        }, [
          _withDirectives(_createElementVNode("textarea", {
            onInput: replicateTextInput,
            ref_key: "textArea",
            ref: textArea,
            rows: "1",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((text).value = $event)),
            onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (send()), ["exact","prevent"]), ["enter"])),
            placeholder: "Skriv en ny melding.."
          }, null, 544), [
            [_vModelText, text.value]
          ])
        ], 512)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("input", {
          type: "file",
          ref_key: "fileInput",
          ref: fileInput,
          class: "visually-hidden"
        }, null, 512),
        (!_unref(isNullOrUndefined)(__props.conversation) && !_unref(demoMode))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "flex items-center justify-center rounded-md py-2 px-2 opacity-70",
              onClick: openFileDialog
            }, _hoisted_8))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: _normalizeClass(["flex items-center justify-center rounded-md py-2 px-2", {
            'sa-spinner': loading.value,
          }]),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (send()))
        }, [
          (loading.value)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_9, _hoisted_11))
            : (_openBlock(), _createElementBlock("svg", _hoisted_12, _hoisted_14))
        ], 2)
      ])
    ], 2)
  ]))
}
}

})